import Header from './header'
import Hero from './hero'
import Mindblowflavour from './mindblowflavour'
import Snakewave from './snakewave'
import Contactus from './contactus'
import Network from './network'
import Subscribe from './subscribe'
import TestimonialSlider from './testimonials'
import Footer from './footer'
import Productslider from './productslider' 
import Instagram from './instagram'
import Nongarlicprocudt from './nongarlicproduct'
const home=()=>{
    return(
        <>
            <Header/>
            <Hero/>
            <Mindblowflavour/>
            <Productslider/>
            <Contactus/>
            <Snakewave/>
            <Nongarlicprocudt/>
            <Network/>
            <TestimonialSlider/>
            <Subscribe/>            
            <Footer/>
        </>
    )
}
export default home